import { z } from "zod";
import { TaskAttemptVersion } from "@remi/enums/task-attempt-version";
import { TaskType } from "@remi/enums/task-type";

const InsuranceElectiveWorkCreatedV1DataSchema = z.object({
  version: z.literal(TaskAttemptVersion.v1),
  estimateId: z.string(),
});

const InsuranceElectiveWorkCreatedDataSchema = z.discriminatedUnion("version", [
  InsuranceElectiveWorkCreatedV1DataSchema,
]);

export const InsuranceElectiveWorkCreatedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_ELECTIVE_WORK_CREATED),
  data: InsuranceElectiveWorkCreatedDataSchema,
});

export type InsuranceElectiveWorkCreatedTaskAttempt = z.infer<typeof InsuranceElectiveWorkCreatedTaskAttemptSchema>;
